
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function About() {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('About Our Instructor')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            NY出身、ロサンゼルス育ちのプロBMXライダーが直接指導
          </p>
        </div>
        
        <div className="max-w-7xl mx-auto">
          {/* メインプロフィールカード */}
          <Card className="mb-12 overflow-hidden">
            <div className="grid lg:grid-cols-3 gap-0">
              {/* 左側：メイン写真 */}
              <div className="lg:col-span-1">
                <img 
                  src="https://static.readdy.ai/image/be5f8d29fa3c2a41001d01b134f26d5e/7ee038b634002b9446b49b8fb3ffc3a7.jfif"
                  alt="Instructor Portrait"
                  className="w-full h-full object-cover min-h-96"
                />
              </div>
              
              {/* 右側：プロフィール情報 */}
              <div className="lg:col-span-2 p-8 lg:p-12">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mr-6">
                    <i className="ri-user-star-line text-3xl text-orange-500"></i>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900">Alex Johnson</h3>
                    <p className="text-lg text-orange-500 font-semibold">プロBMXライダー &amp; 英語講師</p>
                  </div>
                </div>
                
                <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                  {t('Our instructor is from NY and grew up in Los Angeles from high school. He has been riding BMX and was previously sponsored by We The People and Madera BMX Company. After living in California for 10 years, he came to Japan and continues studying Japanese. He graduated from LBCC in California and holds a TEFL (Teaching English as a Foreign Language) qualification. He has been providing private English instruction online for one year. He studies Japanese daily and plans to obtain JLPT N2 by next year.')}
                </p>
                
                {/* 特別プログラム情報 - より目立つデザインに変更 */}
                <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-8 mb-8 text-white shadow-xl border-2 border-orange-300">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4">
                      <i className="ri-star-fill text-orange-500 text-xl"></i>
                    </div>
                    <h4 className="text-2xl font-bold">🎯 特別プログラム開催予定！</h4>
                  </div>
                  <div className="bg-white/20 rounded-lg p-6 backdrop-blur-sm">
                    <p className="text-lg leading-relaxed font-medium">
                      <strong className="text-yellow-200 text-xl">✨ Jesseによる英語を使ったBMXスクールやトリップも不定期開催予定です！</strong>
                    </p>
                    <p className="text-white/90 mt-3 text-base">
                      実際にBMXライディングをしながら英語を学ぶ特別な体験プログラムで、より実践的なスキルアップが可能です。
                    </p>
                    <div className="mt-4 flex items-center text-yellow-200">
                      <i className="ri-information-line mr-2"></i>
                      <span className="text-sm font-medium">詳細は随時お知らせします</span>
                    </div>
                  </div>
                </div>
                
                {/* 資格・経験バッジ */}
                <div className="flex flex-wrap gap-3 mb-8">
                  <div className="bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold">
                    <i className="ri-award-line mr-2"></i>TEFL資格保有
                  </div>
                  <div className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold">
                    <i className="ri-graduation-cap-line mr-2"></i>LBCC卒業
                  </div>
                  <div className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
                    <i className="ri-trophy-line mr-2"></i>元スポンサードライダー
                  </div>
                  <div className="bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-semibold">
                    <i className="ri-translate-line mr-2"></i>日本語学習中
                  </div>
                </div>
              </div>
            </div>
          </Card>
          
          {/* 統計情報とアクション写真 */}
          <div className="grid lg:grid-cols-2 gap-8 mb-12">
            {/* 統計カード */}
            <Card className="p-8">
              <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">実績・経験</h4>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-time-line text-2xl text-orange-500"></i>
                  </div>
                  <p className="text-3xl font-bold text-gray-900">10+</p>
                  <p className="text-gray-600">年間の指導経験</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-group-line text-2xl text-blue-500"></i>
                  </div>
                  <p className="text-3xl font-bold text-gray-900">100+</p>
                  <p className="text-gray-600">指導した生徒数</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-star-line text-2xl text-green-500"></i>
                  </div>
                  <p className="text-3xl font-bold text-gray-900">4.9</p>
                  <p className="text-gray-600">平均評価</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-trophy-line text-2xl text-purple-500"></i>
                  </div>
                  <p className="text-3xl font-bold text-gray-900">2</p>
                  <p className="text-gray-600">スポンサー企業</p>
                </div>
              </div>
            </Card>
            
            {/* アクション写真 */}
            <Card className="overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/be5f8d29fa3c2a41001d01b134f26d5e/89cd5bf9d5486f352ea1809d428e8009.jfif"
                alt="Instructor BMX Action"
                className="w-full h-full object-cover min-h-80"
              />
            </Card>
          </div>
          
          {/* 指導方針カード */}
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="p-6 text-center" hover>
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-2xl text-orange-500"></i>
              </div>
              <h5 className="text-xl font-bold text-gray-900 mb-3">情熱的な指導</h5>
              <p className="text-gray-600">
                BMXへの情熱と英語教育への熱意を組み合わせた、他にはないレッスンスタイル
              </p>
            </Card>
            
            <Card className="p-6 text-center" hover>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-2xl text-blue-500"></i>
              </div>
              <h5 className="text-xl font-bold text-gray-900 mb-3">個別サポート</h5>
              <p className="text-gray-600">
                一人ひとりのレベルと目標に合わせたマンツーマンの丁寧な指導
              </p>
            </Card>
            
            <Card className="p-6 text-center" hover>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-green-500"></i>
              </div>
              <h5 className="text-xl font-bold text-gray-900 mb-3">国際的視野</h5>
              <p className="text-gray-600">
                アメリカと日本の文化を理解し、実践的な英語コミュニケーションを指導
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}
